import type {TrackingProps} from 'src/common/helpers'
import {EVENTS, track} from 'src/common/helpers'
import {Icon} from 'src/common/Icon'

export type LinkArrowProps = {
  href: string
  children: string
  trackingData: Omit<TrackingProps, 'event'>
}

export const LinkArrow = ({href, children, trackingData}: LinkArrowProps) => (
  <a
    href={href}
    onClick={() => track({event: EVENTS.CLICK, ...trackingData})}
    className="group inline-flex items-center gap-2 text-13 font-medium text-green-neon transition-colors hover:text-green-neon-deep"
  >
    <span>{children}</span>
    <Icon name="right-arrow" className="size-[1.15em] transition-transform group-hover:translate-x-0.5" />
  </a>
)
